import { CONTROL, MultiVariantModuleConfig, PayloadsType, TEST } from '../types';

export const getModulePresets = <T = boolean>(moduleConfig: MultiVariantModuleConfig<T>) => ({
  ...moduleConfig,
  ...(moduleConfig.Payloads === undefined && { Payloads: { [CONTROL]: false, [TEST]: true } as PayloadsType<T> }),
  ...(moduleConfig.BootstrapVariant === undefined && { BootstrapVariant: CONTROL }),
});
